module.exports = "/_next/static/images/top-0d02328d8aee1e57b684d20aa9f1efda.jpg";